// @flow
import * as React from 'react';
import NonPaginatedMyBoardsTypeaheadProvider from 'app/common/react/components/MyBoardsTypeaheadProvider/NonPaginatedMyBoardsTypeaheadProvider';
import PaginatedMyBoardsTypeaheadProvider from 'app/common/react/components/MyBoardsTypeaheadProvider/PaginatedMyBoardsTypeaheadProvider';
import type { MyBoardsTypeaheadProviderProps } from 'app/common/react/components/MyBoardsTypeaheadProvider/types';
import { Experiment } from 'app/common/react/components/experiments';

export default function MyBoardsTypeaheadProvider<T>({
  children,
  ...props
}: MyBoardsTypeaheadProviderProps<T>) {
  return (
    <Experiment name="web_paginated_boards">
      {({ anyEnabled }) => {
        const Provider = anyEnabled
          ? PaginatedMyBoardsTypeaheadProvider
          : NonPaginatedMyBoardsTypeaheadProvider;
        return <Provider {...props}>{children}</Provider>;
      }}
    </Experiment>
  );
}
